import { type RecruitingFormSchema, type RecruitingQuerySchema } from '../schemas';

export function recruitingQueryToForm(data: RecruitingQuerySchema): RecruitingFormSchema {
  return {
    ...data,
    linked_in: data.linked_in ?? '',
    recruiting_status_id: data.recruiting_status_id ?? null,
    recruiting_status: data.recruiting_status ?? null,
    notes: data.notes ?? '',
    recruiting_job_categories: data.recruiting_job_categories ?? [],
    hiring_criteria_categories: data.hiring_criteria_categories ?? [],
    phone_numbers: data.phone_numbers ?? [],
    profile_image: data.profile_image ?? [],
    resume: data.resume ?? [],
    additional_documents: data.additional_documents ?? [],
    email: data.email ?? '',
    recruiting_tags: data.recruiting_tags?.split(',').map((tag) => ({ name: tag, value: tag })) ?? [],
  };
}
